export const sizeGuide = {
  clothing: [
    ["Alpha", "Alpha2", "US", "UK", "IT", "FR", "DE", "AUS"], // Header row
    /* START - Data rows*/
    ["XXXS", "-", "00", "2", "34", "30", "28", "2"],
    ["XXS", "XXXS-XXS", "0", "4", "36", "32", "30", "4"],
    ["XS", "XXS-XS", "2", "6", "38", "34", "32", "6"],
    ["S", "XS-S", "4", "8", "40", "36", "34", "8"],
    ["M", "S-M", "6", "10", "42", "38", "36", "10"],
    ["L", "M-L", "8", "12", "44", "40", "38", "12"],
    ["XL", "L-XL", "10", "14", "46", "42", "40", "14"],
    ["XXL", "XL-XXL", "12", "16", "48", "44", "42", "16"],
    ["3X", "2X-3X", "14", "18", "50", "46", "44", "18"],
    ["4X", "3X-4X", "16", "20", "52", "48", "46", "20"],
    /* END - Data rows*/
  ],

  shoes: [
    ["Alpha", "US", "EU/IT", "UK", "FR", "JP"], // Header row
    /* START - Data rows*/
    ["-", "5", " 35", "2", "36", "22"],
    ["-", "5.5", "35.5", "2.5", "36.5", "22.5"],
    ["XS", "6", "36", "3", "37", "23"],
    ["XS-S", "6.5", "36.5", "3.5", "37.5", "23.5"],
    ["S", "7", "37", "4", "38", "24"],
    ["S-M", "7.5", "37.5", "4.5", "38.5", "24.5"],
    ["M", "8", "38", "5", "39", "25"],
    ["M-L", "8.5", "38.5", "5.5", "39.5", "25.5"],
    ["L", "9", "39", "6", "40", "26"],
    ["L-XL", "9.5", "39.5", "6.5", "41", "26.5"],
    ["XL", "10", "40", "7", "41.5", "27"],
    ["-", "10.5", "40.5", "7.5", "42", "27.5"],
    ["-", "11", "41", "8", "42.5", "28"],
    ["-", "11.5", "41.5", "8.5", "43", "28.5"],
    ["-", "12", "42", "9", "43.5", "29"],
    /* END - Data rows*/
  ],

  jeans: [
    ["Alpha", "Alpha2", "US", "UK", "IT", "FR", "DE", "AUS"], // Header row
    /* START - Data rows*/
    ["XXXS", "-", "00", "2", "34", "30", "28", "2"],
    ["XXS", "XXXS-XXS", "0", "4", "36", "32", "30", "4"],
    ["XS", "XXS-XS", "2", "6", "38", "34", "32", "6"],
    ["S", "XS-S", "4", "8", "40", "36", "34", "8"],
    ["M", "S-M", "6", "10", "42", "38", "36", "10"],
    ["L", "M-L", "8", "12", "44", "40", "38", "12"],
    ["XL", "L-XL", "10", "14", "46", "42", "40", "14"],
    ["XXL", "XL-XXL", "12", "16", "48", "44", "42", "16"],
    ["3X", "2X-3X", "14", "18", "50", "46", "44", "18"],
    ["4X", "3X-4X", "16", "20", "52", "48", "46", "20"],
    /* END - Data rows*/
  ],
};
